const initialState = {
  activeSubNav: null,
  calculating: true,
  currentStep: 0,
  details: 0.0,
  mainNavOpened: true,
  palette: null,
  logo: null,
  favicon: null,
  summaryDisclosures: "",
  platformDisclosure: "",
  appName: "",
  disclosureDocumentLocation: "/../assets/Client-disclosures-20210406.pdf",
  useHelpWidget: null,
  useVideoGate: false,
  useEducationDownloadSection: false,
  tcUrl: '',
  educationVideoPath:
    "https://player.vimeo.com/video/574559985?color=ffffff&title=0&byline=0&portrait=0",
  allowRequestCustodialRepCode: true,
  redtailRunningJob: null,
  reportingEnabled: false,
  customizedTheme: false,
  hideFeeSchedule: false,
};

export default function app(state = initialState, action) {
  switch (action.type) {
    case "LOAD_UI_CONFIGS":
      return {
        ...state,
        mainNavOpened: action.payload.mainNavOpened,
      };
    case "SET_ADD_CLIENT_NAV":
      return {
        ...state,
        activeSubNav: action.payload ? "addClient" : null,
      };
    case "SET_ADMIN_NAV":
      return {
        ...state,
        activeSubNav: action.payload ? "admin" : null,
      };
    case "SET_APP_DETAILS":
      return {
        ...state,
        details: action.payload,
      };
    case "SET_EDUCATION_NAV":
      return {
        ...state,
        activeSubNav: action.payload ? "education" : null,
      };
    case "SET_PORTFOLIO_NAV":
      return {
        ...state,
        activeSubNav: action.payload ? "portfolio" : null,
      };
    case "SET_DO_NAV":
      return {
        ...state,
        activeSubNav: action.payload ? "do" : null,
      };
    case "SET_USER_NAV":
      return {
        ...state,
        activeSubNav: action.payload ? "user" : null,
      };
    case "SHOW_CALCULATING_STATE":
      return {
        ...state,
        calculating: action.payload,
      };
    case "TOGGLE_MAIN_NAV":
      return {
        ...state,
        mainNavOpened: action.payload,
      };
    case "UPDATE_PROGRESS_STEP":
      return {
        ...state,
        currentStep: action.payload,
      };
    case "SET_APP_CUSTOM_CONFIGURATION":
      return {
        ...state,
        ...action.payload,
      };
    case "TOGGLE_HELP_WIDGET":
      return {
        ...state,
        helpWidgetOpened: action.payload,
      };
    case "LOAD_USER_APPLICATION_STATE_SUCCESS" : {
      const advisorCustomization = action.payload.advisorCustomization ?
        {...action.payload.advisorCustomization, customizedTheme: true} : {};
      return {
        ...state,
        allowRequestCustodialRepCode: action.payload.allowRequestCustodialRepCode,
        redtailRunningJob: action.payload.redtailRunningJob,
        ...advisorCustomization
      }
    }
    case "SET_APP_CUSTOM_CONFIGURATION_FOR_PDF_PAGE": {
      const customizedTheme = action.payload.customizedTheme ?
        {...action.payload.customizedTheme, customizedTheme: true} : {};
      return {
        ...state,
        ...action.payload.defaultTheme,
        ...customizedTheme
      };
    }
    default:
      return { ...state };
  }
}



// WEBPACK FOOTER //
// ./src/reducers/app.reducer.js